import React from "react";
import { ShoppingCart, ArrowLeft, Send } from "lucide-react";
import { useCart } from "../contexts/CartContext";
import { InstallAppIconButton } from "./InstallApp";

// Lupin-style top bar: black backdrop, "INDIETRO" pill on the left,
// tiny "Link" icon center, neon "CARRELLO" pill on the right.
const Header = ({ onBack, onOpenLinks }) => {
    const { count, setOpen, pulse } = useCart();
    return (
        <header
            className="sticky top-0 inset-x-0 z-50 px-4 pt-4 pb-3 backdrop-blur-md bg-black/40 border-b border-[#7c3aed]/15"
            data-testid="site-header"
        >
            <div className="max-w-5xl mx-auto flex items-center justify-between gap-3">
                {/* Indietro pill */}
                <button
                    type="button"
                    onClick={onBack}
                    className="inline-flex items-center gap-2 px-4 py-2 rounded-full border border-[#7c3aed]/50 bg-[#150826]/70 text-[#e879f9] hover:border-[#e879f9] hover:shadow-[0_0_18px_rgba(232,121,249,0.35)] transition-all active:scale-95"
                    data-testid="header-back"
                    aria-label="Indietro"
                >
                    <ArrowLeft className="w-4 h-4" />
                    <span className="font-mono uppercase tracking-[0.18em] text-xs font-semibold">Indietro</span>
                </button>

                {/* Tiny Link & contatti icon + Install app icon (centered) */}
                <div className="flex items-center gap-2">
                    {onOpenLinks && (
                        <button
                            type="button"
                            onClick={onOpenLinks}
                            className="w-9 h-9 rounded-full border border-[#7c3aed]/50 bg-[#150826]/70 text-[#e879f9] hover:border-[#e879f9] hover:shadow-[0_0_14px_rgba(232,121,249,0.5)] active:scale-90 transition-all flex items-center justify-center"
                            data-testid="header-links"
                            aria-label="Link e contatti"
                            title="Link e contatti"
                        >
                            <Send className="w-3.5 h-3.5" />
                        </button>
                    )}
                    <InstallAppIconButton />
                </div>

                {/* Carrello pill */}
                <button
                    type="button"
                    onClick={() => setOpen(true)}
                    className="relative inline-flex items-center gap-2 px-4 py-2 rounded-full border-2 border-[#7c3aed] bg-[#150826]/85 text-[#e879f9] shadow-[0_0_18px_rgba(124,58,237,0.5)] hover:shadow-[0_0_28px_rgba(232,121,249,0.7)] hover:border-[#e879f9] active:scale-95 transition-all"
                    data-testid="cart-trigger"
                    aria-label="Apri carrello"
                >
                    <ShoppingCart className={`w-4 h-4 ${pulse ? "animate-pulse-soft" : ""}`} />
                    <span className="font-mono uppercase tracking-[0.18em] text-xs font-semibold">Carrello</span>
                    {count > 0 && (
                        <span
                            className={`absolute -top-1.5 -right-1.5 min-w-[20px] h-5 px-1 bg-[#e879f9] text-[#0d0418] text-xs font-bold font-mono rounded-full flex items-center justify-center border-2 border-[#0d0418] shadow-[0_0_10px_rgba(232,121,249,0.7)] ${pulse ? "animate-pulse-soft" : ""}`}
                            data-testid="cart-count"
                        >
                            {count}
                        </span>
                    )}
                </button>
            </div>
        </header>
    );
};

export default Header;
